import {ConnectionStatus} from "@/types/index.ts";

const statusColors: { [key: string]: string } = {
  cancelled: 'bg-gray-100 text-gray-600 opacity-50',
  completed: 'bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-700',
  error: 'bg-red-200 text-red-700',
  failed: 'bg-red-200 text-red-700',
  paused: 'bg-yellow-100 text-yellow-700',
  pending: 'bg-yellow-100 text-yellow-600',
  running: 'bg-gradient-to-r from-sky-100 to-blue-100 text-sky-700',
  'your input required': 'bg-gradient-to-r from-amber-100 to-orange-100 text-amber-700',
};

const connectedStatusColors = (key: string) => {
  switch (key) {
    case ConnectionStatus.CONNECTED:
      return 'bg-green-200 text-green-700';
    case ConnectionStatus.NOT_CONNECTED:
    case ConnectionStatus.LOGIN_ERROR:
      return  'bg-red-200 text-red-700';
    case ConnectionStatus.CHECKING:
      return  'bg-yellow-100 text-yellow-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
}

const getStatusColor = (status: string) => statusColors[status.toLowerCase()];

export { getStatusColor, connectedStatusColors };
